import React from "react";
import { FaLock } from "react-icons/fa";
import "./SOPAccessForm.css";

const SOPAccessForm = ({ code, handleChange, handleSubmit, error }) => {
  return (
    <form onSubmit={handleSubmit} className="_sAForm_j1A_">
      <div className="_lIWrap_k2B_">
        <FaLock className="_lIcon_l3C_" />
      </div>
      <h2 className="_fTitle_m4D_">SOP Access</h2>
      <p className="_fDesc_n5D_">
        This page is restricted.
        <br />
        Please enter the access code.
      </p>
      <input
        type="password"
        placeholder="Enter code"
        value={code}
        onChange={handleChange}
        className="_aInput_o6D_"
      />
      <button type="submit" className="_aBtn_p7D_ _cTAButton_c6F_ _devotee_d7G_">
        Enter
      </button>
      {error && <div className="_eMsg_q8D_">{error}</div>}
    </form>
  );
};

export default SOPAccessForm;
